import React from 'react'

import Typography from '@material-ui/core/Typography'
import moment from 'moment'
import { useTranslate } from 'react-admin'

const format = 'DD/MM/YYYY'

export const StatusSubtitleField = ({
  source,
  record,
  basePath,
  className,
  ...props
}) => {
  const translate = useTranslate()
  return (
    <Typography {...props} className={`${className} ${props.className}`}>
      {source === 'APPROVED' && (
        <> {translate('resources.invoices.messages.approvedDescription')} </>
      )}
      {source === 'PENDINGADVANCE' && (
        <> {translate('resources.invoices.messages.approvedDescription')} </>
      )}
      {source === 'ADVANCED' && (
        <>
          {' '}
          {translate('resources.invoices.messages.advancedDescription').replace(
            '<<advancedDate>>',
            moment.utc(record.requestedAt).format(format)
          )}{' '}
        </>
      )}
      {source === 'DELAYED' && (
        <>
          {' '}
          {translate('resources.invoices.messages.dueDescription').replace(
            '<<dueDate>>',
            moment.utc(record.dueDate).format(format)
          )}{' '}
        </>
      )}
      {source === 'LATE' && (
        <>
          {' '}
          {translate('resources.invoices.messages.dueDescription').replace(
            '<<dueDate>>',
            moment.utc(record.dueDate).format(format)
          )}{' '}
        </>
      )}
      {(source === 'REQUESTED' || source === 'PENDINGREVIEW') && (
        <>
          {' '}
          {translate(
            'resources.invoices.messages.requestedDescription'
          ).replace(
            '<<createdAt>>',
            moment.utc(record.requestedAt).format(format)
          )}{' '}
        </>
      )}
      {source === 'PAID' && (
        <>
          {' '}
          {translate('resources.invoices.messages.paidDescription').replace(
            '<<lastPaymentDate>>',
            moment.utc(record.paidAt).format(format)
          )}{' '}
        </>
      )}
      {source === 'SETTLED' && (
        <>
          {' '}
          {translate('resources.invoices.messages.paidDescription').replace(
            '<<lastPaymentDate>>',
            moment.utc(record.lastPaymentDate).format(format)
          )}{' '}
        </>
      )}
      {source === 'SETTLEMENTCOMPLETED' && (
        <>
          {' '}
          {translate('resources.invoices.messages.paidDescription').replace(
            '<<lastPaymentDate>>',
            moment.utc(record.paidAt).format(format)
          )}{' '}
        </>
      )}
      {source === 'DEFAULTED' && (
        <>
          {' '}
          {translate('resources.invoices.messages.dueDescription').replace(
            '<<dueDate>>',
            moment.utc(record.dueDate).format(format)
          )}{' '}
        </>
      )}
    </Typography>
  )
}
